import ObjClass from "./ObjClass";
import { PersistentData, AppointmentService } from "./Service";
import AppointmentTypeService from "./services/AppointmentTypeService";

export default class AppointmentType extends ObjClass{
	/*constructor(clinicId, id){
        super({});
        let pd = new PersistentData('ClinicData/Clinic/' + clinicId + '/AppointmentTypes');
        this._populate(pd.getData(id));
    }*/

	constructor(json){
		super(json);

		/* if(this.categoryName && !this.name){
            //console.log("Adding NAME proxy for category type:", json)
            Object.defineProperty(this, 'name', {
                get: () => {
                    return this.categoryName;
                },
                set:(val) =>{
                    this.categoryName = val;
                }
            })
        } else {
            if(this.appointmentSourceCd !== 'BIOPED') {
                this.name = `(${this.appointmentSourceCd}) ${this.name}`;
            }
        }*/
	}

	get name() {
		return this.categoryName || (!this.appointmentSourceCd || this.appointmentSourceCd === 'BIOPED'? this.__name:`(CONNECT) ${this.__name}`);
	}

	set name(val){
		if(this.categoryName){
			this.categoryName = val;
		} else {
			this.__name = val;
		}
	}

	_transformProp(p){
		p = super._transformProp(p);
		switch(p.toLowerCase()){
		case 'categoryname':
			p = 'categoryName';
			break;
		case 'appointmenttypeid':
			p = 'appointmentTypeId'
			break;
		case 'name':
			p = '__name';
			break;
		default:
			break;
		}

		return p;
	}

	static GetAll(clinicId){
		let pd = AppointmentTypeService.GetTypeCache(clinicId);// new PersistentData('ClinicData/Clinic/' + clinicId + '/AppointmentTypes')
		return pd.getAll();
	}

	static GetById(id, clinicId){
		let data = AppointmentTypeService.GetType(id, clinicId);
		return new AppointmentType(data);
	}
}

Object.defineProperty(AppointmentType.prototype, 'name', {enumerable: true});



// WEBPACK FOOTER //
// ./src/api/AppointmentType.js